export const ru = {
    caption: '{format} {width}x{height} м',
    'caption-duration': '{duration} сек',
    'caption-format': '{format} {width}×{height} м',
    'caption-resolution': '{width}×{height} px',
    format: '{format} ({width}×{height}, {duration} сек)'
};
